export const updateAuditControlMutation = () => {
    return `
    mutation UpdateAuditControl(
        $auditControlId: Int!,
        $objectiveId: Int,
        $mainSystemId: Int,
        $hrSystemId: Int,
        $ticketSystemId: Int,
        $clearHrSystem: Boolean,
        $clearTicketSystem: Boolean,
        $clearControlIt: Boolean,
        $systemConsolidations: JSONString,
        $dashboardAdditionalInfo: JSONString,
        $controlResultsAdditionalInfo: JSONString,
        $auditId: Int,
        $controlOwnerId: NonEmptyString,
        $controlItId: NonEmptyString,
        $isHidden: Boolean,
        $isAutomated: Boolean,
        $isCreationEqualsOnboardingApproval: Boolean,
        $companyControlId: String,
        $isRecordOwnerEnabled: Boolean
    ) {
        updateAuditControl(
            auditControlId: $auditControlId,
            objectiveId: $objectiveId,
            mainSystemId: $mainSystemId,
            hrSystemId: $hrSystemId,
            ticketSystemId: $ticketSystemId,
            clearHrSystem: $clearHrSystem,
            clearTicketSystem: $clearTicketSystem,
            clearControlIt: $clearControlIt,
            systemConsolidations: $systemConsolidations,
            dashboardAdditionalInfo: $dashboardAdditionalInfo,
            controlResultsAdditionalInfo: $controlResultsAdditionalInfo,
            auditId: $auditId,
            controlOwnerId: $controlOwnerId,
            controlItId: $controlItId,
            isHidden: $isHidden,
            isAutomated: $isAutomated,
            isCreationEqualsOnboardingApproval: $isCreationEqualsOnboardingApproval,
            companyControlId: $companyControlId,
            isRecordOwnerEnabled: $isRecordOwnerEnabled
        ) {
            auditControl {
                id
                isHidden
                isAutomated
                isRecordOwnerEnabled
            }
        }
    }
    `
}
